import { Injectable } from '@angular/core';
import { DataService } from '../architecture/data.service';
import { User } from '../models/user.model';
import { Result } from '../architecture/envelopes';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private dataService: DataService) { }

    public getUser() {
        return this.dataService.get<Result<User>>('Account/GetCurrentUserInfo');
    }

    public getByFilter(page: number, filter: User) {
        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.entity.user', filter.user || '');

        return this.dataService.get<Result<User>>("users", params);
    }
}
